module.exports = __webpack_public_path__ + "img/all-you-can-eat.6a93f778.svg";